import React, { useEffect } from 'react';
import Highcharts from 'highcharts';

interface MyChartProps {
    chartId: string;
    plot: any;
    data: any; // Ahora será un array de objetos { cpu: number, memory: number } cuando es "Process Status"
    title: string;
    subtitle: string;
    yAxisTitle: string;
    selectedCell: string; // Añadimos selectedCell para saber qué métrica estamos graficando
    additionalData?: any[];
}

const MyChartPing: React.FC<MyChartProps> = ({ chartId, plot, data, title, subtitle, yAxisTitle, selectedCell, additionalData }) => {

    useEffect(() => {
        const options: Highcharts.Options = {
            title: {
                text: title,
                align: 'left',
            },
            subtitle: {
                text: subtitle,
                align: 'left'
            },
            yAxis: {
                title: {
                    text: yAxisTitle
                }
            },
            xAxis: {
                type: 'datetime',
                categories: plot,
                labels: {
                    overflow: 'justify'
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },
            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                }
            },
            tooltip: {
                formatter: function () {
                    const pointIndex = this.point.index;
                    const extraData = additionalData ? additionalData[pointIndex] : {};

                    let tooltipText = `<b>${this.series.name}</b><br/>`;
                    tooltipText += `Date: ${this.x}<br/>`;

                    if (selectedCell === 'Port Status') {
                        // Mostrar el estado del puerto en texto claro
                        const portStatus = this.y === 1 ? 'UP' : 'DOWN';
                        tooltipText += `Port Status: ${portStatus}<br/>`;

                        if (extraData && extraData.ports) {
                            const portNumbers = Object.keys(extraData.ports).join(', ');
                            tooltipText += `Ports: ${portNumbers}<br/>`; // Mostrar los números de puertos
                        }
                    } else if (selectedCell === 'Process Status') {
                        // Mostrar datos de CPU y Memory en el tooltip para "Process Status"
                        tooltipText += `CPU Percent: ${this.y}%<br/>`;
                        tooltipText += `Execution Time: ${extraData.executionTimes || 'N/A'}<br/>`;
                    } else {
                        // Mostrar datos de CPU, RAM o Storage
                        tooltipText += `Avg: ${this.y}%<br/>`;
                        if (extraData) {
                            tooltipText += `Free: ${extraData.free || 'N/A'}<br/>`;
                            tooltipText += `Used: ${extraData.used || 'N/A'}<br/>`;
                            tooltipText += `Total: ${extraData.total || 'N/A'}<br/>`;
                        }
                    }

                    return tooltipText;
                }
            },
            series: selectedCell === 'Process Status'
                ? [
                    {
                        type: 'line',
                        name: 'CPU Percent',
                        data: data.map((item: any) => item.cpu), // Datos de CPU Percent
                    },
                    {
                        type: 'line',
                        name: 'Memory Percent',
                        data: data.map((item: any) => item.memory), // Datos de Memory Percent
                    }
                ]
                : [{
                    type: 'line',
                    name: selectedCell === 'Port Status' ? 'Port Status' : `Avg ${selectedCell}`,
                    data: selectedCell === 'Port Status'
                        ? data.map((item: number) => item === 1 ? 1 : 0) // Para Port Status, 1 para UP, 0 para DOWN
                        : data // Para las demás métricas, simplemente usamos los valores de `data`
                }],
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            credits: {
                enabled: false
            }
        };

        Highcharts.chart(`container-${chartId}`, options);
    }, [chartId, plot, data, title, subtitle, yAxisTitle, additionalData, selectedCell]);

    return (
        <div id={`container-${chartId}`}>
            {/* El contenedor div donde se renderizará el gráfico */}
        </div>
    );
};

export default MyChartPing;
